import React, { useState, useEffect } from "react";
import axios from 'axios';
import { AiOutlineEdit } from "react-icons/ai";
import { Button, Card } from "react-bootstrap";
import { IoMdAddCircle } from "react-icons/io";
import Select from "react-select";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import { FaCheckCircle } from "react-icons/fa";
function CustomPlan() {
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [services, setServices] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [paymentId, setPaymentId] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [formData, setFormData] = useState({
    rec_date: "",
    end_date: "",
    amount: ""
  });
  const [selectedServices, setSelectedServices] = useState([]);
  const handleTimeChange = (index, value) => {
    const updated = [...selectedServices];
    updated[index].no_times = Number(value) || 1;
    setSelectedServices(updated);
    setFormData(prev => ({
      ...prev,
      service_name: updated
    }));
  };
  const inputStyle = {
    background: "#1e293b",
    color: "#fff",
    border: "1px solid #334155"
  };
  const handleCancel = () => {
    setFormData({
      rec_date: "",
      end_date: "",
      amount: ""
    });
    setSelectedServices([]);
    setIsEditMode(false);
    setShowForm(false);
  };
  const monthOptions = Array.from({
    length: 12
  }, (_, i) => ({
    value: i + 1,
    label: `${i + 1} month${i + 1 > 1 ? 's' : ''}`
  }));
  const handleRemoveServiceRow = index => {
    const updated = selectedServices.filter((_, i) => i !== index);
    setSelectedServices(updated);
    setFormData(prev => ({
      ...prev,
      service_name: updated
    }));
  };
  const handleServiceSelect = (index, serviceId) => {
    const selected = services.find(s => s.value == serviceId);
    const updated = [...selectedServices];
    updated[index] = {
      sId: selected?.value || "",
      name: selected?.label || "",
      sale_price: selected?.sale_price || 0,
      no_times: updated[index].no_times || 1,
      s_type: updated[index].s_type || "Daily"
    };
    setSelectedServices(updated);
    setFormData(prev => ({
      ...prev,
      service_name: updated
    }));
  };
  const handleAddServiceRow = () => {
    setSelectedServices(prev => [...prev, {
      sId: "",
      name: "",
      sale_price: 0,
      s_type: "Daily",
      no_times: 1
    }]);
  };
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => {
      const updated = {
        ...prev,
        [name]: value
      };
      return updated;
    });
  };
  const fetchSubHistory = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-subscription-history?from=${fromDate}&to=${toDate}`);
      const filteredData = res.data.filter(item => item.sub_type !== "Confirmed");
      setData(filteredData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchSubHistory();
  }, []);
  const filteredData = Array.isArray(data) ? data.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  const handleMonthChange = selectedOption => {
    setFormData(prev => ({
      ...prev,
      months: selectedOption?.value || ""
    }));
  };
  const handleEdit = data => {
    // console.log(data)
    setIsEditMode(true);
    setEditId(data.id);
    setFormData({
      rec_date: data.rec_date,
      end_date: data.end_date,
      amount: data.amount
    });
    let parsedServices = [];
    try {
      parsedServices = typeof data.service_name === "string" ? JSON.parse(data.service_name) : data.service_name || [];
    } catch (e) {
      console.log("Invalid JSON");
    }
    const formattedServices = parsedServices.map(s => ({
      sId: String(s.sId),
      name: s.name,
      sale_price: s.sale_price,
      no_times: s.no_times || 1,
      s_type: s.s_type || "Daily"
    }));
    setSelectedServices(formattedServices);
    setShowForm(true);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const serviceJson = JSON.stringify(selectedServices.map(s => ({
        sId: Number(s.sId),
        name: s.name,
        sale_price: Number(s.sale_price),
        no_times: Number(s.no_times),
        s_type: s.s_type
      })));
      const payload = {
        id: editId,
        rec_date: formData.rec_date,
        end_date: formData.end_date,
        amount: formData.amount,
        service_name: selectedServices
      };
      await axios.put(`https://api.sweepydo.in/update-subscription-history/${editId}`, payload);

      // alert("Updated successfully ✅");
      showToast("Plan Updated Successfully", "success");
      fetchSubHistory();
      handleCancel();
    } catch (error) {
      console.log(error);
      showToast("Fail To Update Plan", "danger");
    }
  };

  //     const handleUpdateStatus = async () => {
  //   try {
  //     if (!selectedRow) return;

  //     await axios.put(
  // Configuration details withheld; supply approved runtime settings. 
  //       {
  //         status: "Success",
  //          payment_id: paymentId,
  //         payment_mode: paymentMode
  //       }
  //     );

  //     showToast("Payment marked as Success",'success');

  //      setShowConfirm(false);
  //     setSelectedRow(null);
  //      setPaymentId("");
  //     setPaymentMode("");

  //     fetchSubHistory();

  //   } catch (error) {
  //     console.log(error);

  //       showToast("Failed to update status ",'danger')
  //   }
  // };

  const handleUpdateStatus = async () => {
    try {
      if (!selectedRow?.id) {
        showToast("Invalid row", "danger");
        return;
      }
      const payload = {
        status: "Success"
      };
      if (paymentId?.trim()) {
        payload.payment_id = paymentId;
      }
      if (paymentMode) {
        payload.payment_mode = paymentMode;
      }
      await axios.put(`https://api.sweepydo.in/update-payment-status/${selectedRow.id}`, payload);
      showToast("Payment updated successfully ✅", "success");
      setShowConfirm(false);
      setSelectedRow(null);
      setPaymentId("");
      setPaymentMode("");
      fetchSubHistory();
    } catch (error) {
      console.log(error);
      showToast("Failed to update status", "danger");
    }
  };
  return <div className="container-fluid mt-3" style={{
    minHeight: "100vh"
  }}>

             <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
            <h2 className="mb-4 text-white text-center">Custom Plan</h2>

            <div className="card shadow-lg border-0 p-3" style={{
      background: "var(--black)",
      borderRadius: "12px"
    }}>
                <div style={{
        background: "var(--black)",
        borderRadius: "12px",
        padding: "15px"
      }}>


                    {showForm && <Card className="p-4 mb-4" style={{
          background: "var(--black)",
          borderRadius: "12px",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.4)"
        }}>
                            <form onSubmit={handleSubmit}>

                                <div className="row mb-3">

                                    <div className="col-lg-6 col-md-6 col-12">
                                        <label className="form-label text-white">Plan Start Date</label>

                                        <input type="datetime-local" name="rec_date" value={formData.rec_date} onChange={handleInputChange} className="form-control" style={inputStyle} required />

                                    </div>

                                    <div className="col-lg-6 col-md-6 col-12">
                                        <label className="form-label text-white">Plan End Date</label>

                                        <input type="datetime-local" name="end_date" value={formData.end_date} onChange={handleInputChange} className="form-control" style={inputStyle} required />

                                    </div>

                                </div>


                                <div className="row mb-3">

                                    <div className="col-lg-6 col-md-6 col-12">
                                        <label className="form-label text-white">Amount</label>
                                        <input type="number" name="amount" value={formData.amount} onChange={handleInputChange} className="form-control" style={inputStyle} />
                                    </div>
                                </div>



                                <div className="mb-5">


                                    {selectedServices.map((item, index) => <div key={index} className="d-flex gap-2 align-items-center mt-3">


                                            <input type="text" className="form-control" style={inputStyle} value={item.name} readOnly />

                                            {/* Service Type */}
                                            <select className="form-control" style={{
                  width: "120px",
                  ...inputStyle
                }} value={item.s_type} onChange={e => {
                  const updated = [...selectedServices];
                  updated[index].s_type = e.target.value;
                  setSelectedServices(updated);
                }}>
                                                <option value="Daily">Daily</option>
                                                <option value="Weekly">Weekly</option>
                                            </select>

                                            {/* Duration */}
                                            <input type="number" min="1" className="form-control" style={{
                  width: "100px",
                  ...inputStyle
                }} value={item.no_times} onChange={e => handleTimeChange(index, e.target.value)} />

                                            <span className="text-white col-1 text-center border rounded py-1">
                                                ₹{item.sale_price * item.no_times}
                                            </span>

                                            <button type="button" className="btn btn-danger btn-sm" onClick={() => handleRemoveServiceRow(index)}>
                                                Remove
                                            </button>
                                        </div>)}


                                </div>


                                <div className="d-flex justify-content-end mb-2">

                                    <Button type="submit" variant="success">
                                        {isEditMode ? "Update" : "Save"}
                                    </Button>

                                    <Button variant="danger" onClick={handleCancel} className="ms-2">
                                        Cancel
                                    </Button>
                                </div>
                            </form>
                        </Card>}




                    <div className="card-header  d-flex justify-content-between align-items-center flex-wrap gap-2 py-4">

                        {/* Search */}
                        <input type="text" className="form-control w-auto p-2" placeholder="Search by name ,number..." style={{
            background: "#1e293b",
            color: "#fff",
            border: "1px solid #334155",
            minWidth: "250px"
          }} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

                        {/* Right Actions */}
                        <div className="d-flex gap-2">

                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="text-center" style={{
            width: "100%",
            borderCollapse: "collapse",
            color: "#fff"
          }}>

                            <thead>
                                <tr style={{
                backgroundColor: "var(--black2)"
              }}>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SN</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>USER NAME</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>MOBILE</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>Amount</th>
                                       <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>Payment Mode</th>
                                          <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>Payment Status</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>Start Date</th>

                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>End Date</th>

                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ACTIONS</th>
                                </tr>
                            </thead>


                            {filteredData.map((s, i) => <tr key={s.id} style={{
              backgroundColor: "var(--black)",
              borderBottom: "1px solid rgba(255,255,255,0.06)",
              transition: "0.3s"
            }} onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = "var(--black2)";
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "var(--black)";
            }}>
                                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}> {i + 1}</td>
                                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.user_name} </td>
                                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.user_mobile} </td>
                                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.amount} </td>
                                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.payment_mode} </td>
                                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.status} </td>
                                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.rec_date} </td>

                                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.end_date} </td>

                                    <td>
                                        <AiOutlineEdit size={20} className="text-primary" onClick={() => handleEdit(s)} />
                                      <FaCheckCircle size={20} title="Updated payment status" color={s.status === "Success" ? "gray" : "green"} style={{
                  cursor: s.status === "Success" ? "not-allowed" : "pointer",
                  marginLeft: "10px"
                }} onClick={() => {
                  if (s.status !== "Success") {
                    setSelectedRow(s);
                    setShowConfirm(true);
                  }
                }} />
                                    </td>

                                </tr>)}

                        </table>
                    </div>



{showConfirm && <div className="modal fade show" style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.6)"
        }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content" style={{
              background: "var(--black2)",
              color: "#fff"
            }}>

        <div className="modal-header border-0">
          <h5 className="modal-title">Confirm Payment</h5>
          <button className="btn-close btn-close-white" onClick={() => setShowConfirm(false)}></button>
        </div>

        <div className="modal-body">

          <p>Are you sure you want to mark this payment as <b>Success</b>?</p>

          {/* ✅ Payment ID */}
          <div className="mb-3">
            <label className="form-label text-white">Payment ID</label>
            <input type="text" className="form-control" value={paymentId} onChange={e => setPaymentId(e.target.value)} placeholder="Enter Payment ID" />
          </div>

          {/* ✅ Payment Mode */}
          <div className="mb-3">
            <label className="form-label text-white">Payment Mode</label>
            <select className="form-control" value={paymentMode} onChange={e => setPaymentMode(e.target.value)}>
              <option value="">Select Mode</option>
              <option value="Cash">Cash</option>
              <option value="QR">QR</option>
            </select>
          </div>

        </div>

        <div className="modal-footer border-0">
          <button className="btn btn-secondary" onClick={() => setShowConfirm(false)}>
            Cancel
          </button>

          <button className="btn btn-success" onClick={handleUpdateStatus}>
            Yes, Update
          </button>
        </div>

      </div>
    </div>
  </div>}

                </div>

            </div>

        </div>;
}
export default CustomPlan;
